"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetReferenceCount = void 0;
const message_1 = require("../message");
const private_1 = require("../utils/private");
/**
 * Maintaining the reference count of the view cache.
 */
class ReferenceCount {
    constructor() {
        this.referenceCountMap = new Map();
    }
    /**
     * Get all subscription views.
     */
    getSubscribeMap() {
        const res = [];
        this.referenceCountMap.forEach((v, k) => {
            res.push(...Object.keys(v).map(viewId => ({ datasheetId: k, viewId })));
        });
        return res;
    }
    add(datasheetId, viewId, widgetId) {
        const datasheetCount = this.referenceCountMap.get(datasheetId);
        const viewCount = (datasheetCount === null || datasheetCount === void 0 ? void 0 : datasheetCount[viewId]) || 0;
        if (!datasheetCount) {
            this.referenceCountMap.set(datasheetId, { [viewId]: 1 });
            this.notify(widgetId);
            return;
        }
        this.referenceCountMap.set(datasheetId, Object.assign(Object.assign({}, datasheetCount), { [viewId]: viewCount + 1 }));
        this.notify(widgetId);
    }
    remove(datasheetId, viewId, widgetId) {
        const datasheetCount = this.referenceCountMap.get(datasheetId);
        const viewCount = datasheetCount === null || datasheetCount === void 0 ? void 0 : datasheetCount[viewId];
        if (!datasheetCount || !viewCount) {
            return;
        }
        this.referenceCountMap.set(datasheetId, Object.assign(Object.assign({}, datasheetCount), { [viewId]: viewCount - 1 }));
        this.maintainCount(datasheetId);
        this.notify(widgetId);
    }
    /**
     * Maintenance count.
     * 1. Clear out the key with count 0.
     * 2. Clear the key of an object whose referenceCount is empty.
     */
    maintainCount(datasheetId) {
        const referenceCount = this.referenceCountMap.get(datasheetId);
        if (!referenceCount) {
            return;
        }
        Object.keys(referenceCount).forEach(viewId => {
            if (referenceCount.hasOwnProperty(viewId) && referenceCount[viewId] < 1) {
                delete referenceCount[viewId];
            }
        });
        if (Object.keys(referenceCount).length === 0) {
            this.referenceCountMap.delete(datasheetId);
            return;
        }
        this.referenceCountMap.set(datasheetId, referenceCount);
    }
    clear(widgetId) {
        this.referenceCountMap.clear();
        this.notify(widgetId);
    }
    /**
     * Notify the main thread of a change in subscription count.
     */
    notify(widgetId) {
        (0, private_1.isSandbox)() ?
            message_1.widgetMessage.syncWidgetSubscribeView(this.getSubscribeMap()) :
            message_1.eventMessage.syncWidgetSubscribeView(this.getSubscribeMap(), widgetId);
    }
}
exports.widgetReferenceCount = new ReferenceCount();
